export default function VisaLogo() {
  return (
    <svg
      width="37"
      height="16"
      viewBox="0 0 37 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3205 2.01889L15.8484 14.0117H12.8584L15.3305 2.01889H18.3205ZM30.8982 9.76269L32.4726 5.259L33.3769 9.76269H30.8982ZM34.2357 14.0117H37L34.5849 2.01889H32.0343C31.4591 2.01889 30.9757 2.3653 30.7612 2.89805L26.2749 14.0117H29.4146L30.0373 12.2202H33.8733L34.2357 14.0117ZM26.4308 10.0961C26.4433 6.93152 22.2143 6.75598 22.2419 5.34186C22.2521 4.91209 22.6466 4.45436 23.5103 4.33742C23.9382 4.28005 25.1201 4.2342 26.4589 4.87433L26.9827 2.32976C26.2633 2.05983 25.3377 1.79995 24.1862 1.79995C21.2305 1.79995 19.1513 3.42908 19.1348 5.76379C19.1154 7.49074 20.6198 8.45326 21.7512 9.02842C22.9166 9.61584 23.3074 9.99339 23.3019 10.5183C23.2937 11.3229 22.3714 11.6792 21.5138 11.6924C20.0101 11.7172 19.1383 11.2707 18.4431 10.9346L17.9004 13.5635C18.5999 13.8962 19.8891 14.1852 21.2244 14.2C24.3665 14.2 26.4216 12.5895 26.4308 10.0961ZM14.0479 2.01889L9.20393 14.0117H6.04342L3.65946 4.44039C3.51511 3.85224 3.38943 3.63575 2.94954 3.38716C2.23064 2.9819 1.0435 2.60287 0 2.36702L0.0704007 2.01889H5.15844C5.806 2.01889 6.38905 2.46631 6.53718 3.24104L7.79685 10.1814L10.9066 2.01889H14.0479Z"
        fill="#1A1F71"
      />
    </svg>
  );
}
